module.exports = __webpack_public_path__ + "img/switchOn.png?2adb3ece1f60a0dbbd95648b2185c018";